import React from "react";
import { useTranslation } from "react-i18next";
import { FiGlobe } from "react-icons/fi";
import "./LanguageSwitcher.css";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const isEnglish = i18n.language === "us";

  const toggleLanguage = () => {
    const newLang = isEnglish ? "al" : "us";
    i18n.changeLanguage(newLang);
    localStorage.setItem("userLang", newLang);
  };

  return (
    <button
      type="button"
      className={`language-switcher ${isEnglish ? "english" : "albanian"}`}
      onClick={toggleLanguage}
      aria-label={`Switch to ${isEnglish ? "Albanian" : "English"}`}
    >
      <FiGlobe aria-hidden="true" />
      <span>{isEnglish ? "EN" : "AL"}</span>
    </button>
  );
};

export default LanguageSwitcher;
